const apiUrl = process.env.REACT_APP_API_URL;

const getSampleActionsNeeded = (token, id, cb) => {
    fetch(`${apiUrl}/conditionreportactionsneeded/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getSampleActionsNeeded;
